import { render, staticRenderFns } from "./RegistrationStepThree.vue?vue&type=template&id=5920f960&scoped=true"
import script from "./RegistrationStepThree.vue?vue&type=script&lang=js"
export * from "./RegistrationStepThree.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStepThree.vue?vue&type=style&index=0&id=5920f960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920f960",
  null
  
)

export default component.exports